import { Box, IcPaymentTypeCreditCard, Text } from '@fozito/common-ui';
import clsx from 'clsx';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { IMultiCardResDataItem } from './index.interface';
type Props = {
  remaining: number;
  cards: IMultiCardResDataItem[];
  v2?: boolean;
};
const DetailPayment = ({ remaining, cards, v2 }: Props) => {
  return (
    <Container className={clsx(v2 && 'v2')}>
      <div className='cards'>
        {!!cards?.length && (
          <Box
            display="flex"
            flexDirection="column"
            paddingTop={24}
            paddingLeft={24}
            paddingRight={24}
          >
            {cards.map((item) => {
              return (
                <Box className="space-between" key={item.id}>
                  <Box display='flex' alignItems='center' gap={16}>
                    <IcPaymentTypeCreditCard width={32} height={32} />
                    <Text title_h6_20_regular>
                      {item.last4 || '--'}
                    </Text>
                  </Box>
                  <Text title_h6_20_regular>
                    {formatCurrency(item.amount)}
                  </Text>
                </Box>
              );
            })}
          </Box>
        )}
      </div>
      <BottomStyled>
        <Box className="space-between box remaining-box" padding={16} paddingRight={24} paddingLeft={24}>
          <Text title_h5_24_semibold>
            Remaining
          </Text>
          <Text title_h3_28_semibold>
            {remaining >= 0 ? formatCurrency(remaining) : 0}
          </Text>
        </Box>
      </BottomStyled>
    </Container>
  );
};

export default DetailPayment;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  .cards {
    flex: 1;
  }
&.v2 {
  .cards {
    .card-label, .card-value {
      font-size: 20px;
    }
  }
  .remaining-box {
    background: #FEEDBF;
    .remaining-label {
      color: #1D2129;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .remaining-value {
      color: #1D2129;
      text-align: right;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
}
`;

const BottomStyled = styled(Box)`
  padding: 1rem 0;
  .box {
    height: 3.5rem;
  }
`;
